import { useApiInspectionsV1LoadsList } from 'api';

export const useAllDealLoads = (dealId: number) => {
  return useApiInspectionsV1LoadsList(
    {
      deal_id: [dealId],
      page_size: 10000, // fetch all loads
    },
    {
      query: {
        enabled: !!dealId,
      },
    }
  );
};
